import { render } from "./InfoPrivacy.vue?vue&type=template&id=1c977c86&scoped=true"
import script from "./InfoPrivacy.vue?vue&type=script&lang=js"
export * from "./InfoPrivacy.vue?vue&type=script&lang=js"

import "./InfoPrivacy.vue?vue&type=style&index=0&id=1c977c86&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c977c86"]])

export default __exports__